"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToSKeyWithCtrl = void 0;
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("../../../rxjs");
var filter_key_is_down_1 = require("../filter-key-is-down");
var filter_target_alphabet_key_event_1 = require("../filter-target-alphabet-key-event");
var map_to_ctrl_key_is_down_1 = require("./map-to-ctrl-key-is-down");
var mapToSKeyWithCtrl = function () { return function (keyEvent$) {
    return keyEvent$.pipe((0, filter_target_alphabet_key_event_1.filterTargetAlphabetKeyEvent)('s'), (0, filter_key_is_down_1.filterKeyIsDown)(), (0, rxjs_1.filterByLatest)(keyEvent$.pipe((0, map_to_ctrl_key_is_down_1.mapToCtrlKeyIsDown)())), (0, operators_1.map)(function (ev) {
        ev.preventDefault();
        return ev;
    }));
}; };
exports.mapToSKeyWithCtrl = mapToSKeyWithCtrl;
